import { request, mountUrl } from './utils'
import ls from './localStorage'
import { env } from './config'
import { getPermission } from '~/geoHelper'
import Cookies from '~/cookie'

const isAnonymous = Cookies.get('session-mode')?.toLowerCase().includes('anonimo')

function makeHash(prefix) {
  return `${prefix}-${Date.now()}-${Math.random() * 1000}`
}

function createLogger() {
  const fingerprint = ls.getItem('finger') || ls.setItem('finger', makeHash('finger'))
  let sessionId
  let position

  return {
    setPosition(newValue) {
      position = newValue
      sessionId = makeHash('session')
      // this.emit('sessionStart', { referrer: document.referrer, href: window.location.href })
    },

    emit(action, data) {
      data.brand = data.brand || window.appData.cnpj

      request(`${env.PREFIX}/logger`, {
        method: 'POST',
        body: { position, action, data, sessionId, fingerprint }
      })
    },

    getSessionId() {
      return 'teste-deletar'
      // return sessionId
    }
  }
}

export const logger = createLogger()

function filterDateLimit(item) {
  if (!item.limitDate) {
    return true
  }
  const [year, month, day] = item.limitDate.split('-').map((n) => parseInt(n))
  const limitDate = new Date(year, month - 1, day - 1, 23, 59)
  return limitDate > new Date()
}

function orderFeatured(products) {
  if (!products) return null
  if (!window.appData.featured) return products

  let listFeatured = []

  window.appData.featured
    .filter(filterDateLimit)
    .slice(0, 5)
    .forEach((item) => {
      const product = products.find((p) => p.gtin === item.gtin)

      if (product && listFeatured.length < 5) {
        listFeatured.push({ ...product, featured: item })
      }
    })

  listFeatured = listFeatured.sort((a, b) => (a.featured.order < b.featured.order ? -1 : 1))

  return listFeatured.concat(products.filter((p) => !listFeatured.find((f) => f.gtin === p.gtin)))
}

// factory
function createApi() {
  return {
    async getProducts(cnpj) {
      const items = await request(`${env.PREFIX}/products2`, { params: { cnpj } })
      return orderFeatured(items)
    },

    async getStores({ gtins, lng, ...params }) {
      const geoLocation = await getPermission()
      const sessionMode = Cookies.get('session-mode')
      const response = await request(`${env.PREFIX}/search-stores2/${gtins}`, {
        params: { ...params, lon: lng, geoLocation, sessionMode }
      })

      if (response.stores.length === 0) {
        throw new Error('empty_stores')
      }

      return response
    },

    // busca de produtos por termos (name)
    async search({ lat, lng, cnpj: brand = '', partner = '', name, gtin }) {
      const sessionMode = Cookies.get('session-mode')
      const params = { name, lat, lng, partner, brand, gtin, sessionMode }
      const products = await request(`${env.PREFIX}/search-products2`, { params })

      return products
    },

    clickTrack({ event, ...data }) {
      if (isAnonymous) {
        console.warn(`~ 🥷 ANONYMOUS MODE AVAILABLE - log "${event}" not sent ~ \n`, data)
        return
      }
      return logger.emit(event, data)
    },

    getStoreDetails(cnpj) {
      return request(`${env.PREFIX}/store/${cnpj}/details`)
    },

    getStoreProducts(cnpj) {
      return request(`${env.PREFIX}/store/${cnpj}/products`)
    },

    retailMessage(body) {
      return request(`${env.PREFIX}/retailermessage`, {
        method: 'POST',
        body
      })
    },

    getLabel(
      {
        address: { label, houseNumber, street, district, city, state, county, postalCode },
        matchLevel,
        localityType,
        resultType
      },
      getLiteral
    ) {
      if (label) return label

      const type = matchLevel || localityType || resultType
      const province = state || county

      if (type === 'houseNumber')
        return `${street}, ${houseNumber}, ${
          district ? ` ${district} - ` : ''
        }${city} - ${province}`
      if (type === 'street')
        return `${street}, ${district ? ` ${district} - ` : ''}${city} - ${province}`
      if (type === 'district') return `${getLiteral('1284')}: ${district}, ${city} - ${province}`
      if (type === 'city') return `${getLiteral('1231')}: ${city} - ${province}`
      if (type === 'state' || type === 'county') return `${getLiteral('1443')}: ${province}`
      if (type === 'postalCode')
        return `${getLiteral('1444')}: ${postalCode}, ${city} - ${province}`
    },

    fetchGeoCode({
      address: { country, state, street = '', houseNumber = '', city = '', postalCode = '' },
      id
    }) {
      // console.log({ id })
      let params, endpoint

      if (id) {
        params = {
          apiKey: env.HERE_REST_APIKEY,
          id: encodeURI(id)
        }
        endpoint = 'lookup'
      } else {
        const s = (key, value) => {
          if (value !== '') return `${key}=${value};`
          else return ''
        }

        params = {
          apiKey: env.HERE_REST_APIKEY,
          show: 'countryInfo',
          qq: encodeURI(
            `${s('country', country)}${s('state', state)}${s('street', street)}${s(
              'houseNumber',
              houseNumber
            )}${s('city', city)}${s('postalCode', postalCode)}`.slice(0, -1)
          )
        }
        endpoint = 'geocode'
      }

      // console.log({ params })

      return request(mountUrl(`https://geocode.search.hereapi.com/v1/${endpoint}`, params), {
        contentType: false
      })
    },

    fetchGeoCodeGoogle(address) {
      return request(mountUrl(`${env.PREFIX}/geocode`, { address }), {
        contentType: false
      })
    },

    fetchReverseGeocode({ lat, lng }) {
      const params = {
        at: `${lat}%2C${lng}`,
        lang: 'pt-BR',
        limit: 1,
        apiKey: env.HERE_REST_APIKEY
      }
      return request(mountUrl('https://revgeocode.search.hereapi.com/v1/revgeocode', params), {
        contentType: false
      })
    },

    searchLocation(input, config) {
      const country = config?.country
      const params = {
        q: encodeURIComponent(input),
        in: `countryCode:${country ? country : 'BRA'}`,
        lang: config.language ? config.language : 'pt-BR',
        apiKey: env.HERE_REST_APIKEY
      }

      return request(mountUrl('https://geocode.search.hereapi.com/v1/autocomplete', params), {
        contentType: false
      }).then((res) => {
        return res.items
          ? res.items.filter((item) => Object.keys(item.address).includes('city'))
          : []
      })
    },

    reportProblem({ store, product, position, type, text }) {
      const body = {
        type,
        text,
        storeName: store.name,
        address: store.address,
        storeAddress: store.formattedAddress,
        productName: product.name,
        storeLocation: `${store.lat}, ${store.long}`,
        gtin: product.gtin,
        userLocation: `${position.lat},${position.lng}`,
        CNAE: store.CNAE,
        brand: store.brand,
        cnpj: store.cnpj,
        suppliers: store.suppliers,
        locatorExtraInfo: store.locatorExtraInfo
      }

      return request(`${env.PREFIX}/report`, { method: 'POST', body })
    },

    ecommerce(gtin) {
      const params = {
        gtin
      }

      return request(`${env.PREFIX}/ecommerce-list`, { method: 'GET', params })
    },

    ecommerceGoogle(gtin, location) {
      const params = {
        gtin,
        location
      }

      return request(`${env.PREFIX}/ecommerce-google-list`, { method: 'GET', params })
    },

    ecommerceHistoryInsights(gtin, period) {
      const params = {
        gtin,
        period
      }

      return request(`${env.PREFIX}/ecommerce-google-history`, { method: 'GET', params })
    },

    onlineStore() {
      return request(`${env.PREFIX}/online-store`, { method: 'GET' })
    },

    postAlertPrice(params) {
      return request(`${env.PREFIX}/online-store-email-price-alarms`, {
        method: 'POST',
        body: params
      })
    },

    postWhatsappData(params) {
      return request(`${env.PREFIX}/form-whatsapp`, { method: 'POST', params })
    },

    gmbStore(cnpj) {
      const params = { cnpj }
      return request(`${env.PREFIX}/gmb-details`, { method: 'GET', params })
    }
  }
}

export default createApi()
